/* storybook-check-ignore */
import { Modal } from '@opendoor/bricks/complex';
import { Flex, Button, Text } from '@opendoor/bricks/core';
import { exclusives } from '@opendoor/bricks/theme';
import { ThemedLite } from '@opendoor/bricks/theme/ODThemeLite';
import { Listing } from 'declarations/exclusives/listing';
import moment from 'moment-timezone';
import { ReserveATourSlotContentProps } from './ReserveATourSlotContent';
import { DEFAULT_TIMEZONE } from './util';

export default function ReserveATourSelectedSpotConfirmationModal({
  onClose,
  onConfirm,
  listing,
  slot,
}: {
  onClose: () => void;
  onConfirm: () => void;
  listing: Listing;
  slot: ReserveATourSlotContentProps['slot'];
}) {
  if (!slot) return null;
  const startTime = moment(slot.start_time).tz(listing.timezone || DEFAULT_TIMEZONE);
  const endTime = moment(slot.end_time).tz(listing.timezone || DEFAULT_TIMEZONE);
  return (
    <Modal
      headerProps={{
        title: (
          <>
            Confirm Open House{' '}
            {
              <Text as="span" display={['none', 'none', 'inline-block']} fontWeight="bold">
                Spot
              </Text>
            }
          </>
        ) as any,
      }}
      analyticsName=""
      isOpen
      onRequestClose={onClose}
      mobileSize="sheet"
      desktopAndTabletSize="sm"
    >
      <ThemedLite theme={exclusives}>
        <Flex flexDirection="column" gridGap="2rem">
          <Text fontSize="s1">
            Please confirm that you can make the Open House for {listing.address.human_readable} on{' '}
            {startTime.format('MMM DD')} from {startTime.format('h:mma').replace(':00', '')} to{' '}
            {endTime.format('h:mma').replace(':00', '')}
          </Text>
          <Flex flexDirection="row" gridGap="1rem">
            <Button analyticsName="" aria-label={null} onClick={onConfirm}>
              Yes
            </Button>
            <Button variant="secondary" analyticsName="" aria-label={null} onClick={onClose}>
              Cancel
            </Button>
          </Flex>
        </Flex>
      </ThemedLite>
    </Modal>
  );
}
